import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollectionItemComponent } from 'src/app/features/create-questionnaire-page/component/collection-item/collection-item.component';
import { CollectionQuestionsStore } from '../../stors/collection-questions-store';
import { Question } from 'src/app/models/question.model';
import { QuestionFormComponent } from 'src/app/features/create-questionnaire-page/component/question-form/question-form.component';
import { DragStore } from 'src/app/store/drag-store';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MiniOperationsStore } from 'src/app/store/mini-operations-store';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';

@Component({
    selector: 'que-questions-collection',
    imports: [CommonModule, CollectionItemComponent, QuestionFormComponent, ReactiveFormsModule],
    templateUrl: './questions-collection.component.html',
    styleUrls: ['./questions-collection.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionsCollectionComponent {
  #collectionStore = inject(CollectionQuestionsStore);

  colllection$ = this.#collectionStore.collection$;
  questionControl = new FormControl<Question | null>(null);
  constructor() {
    this.#collectionStore.fetchCollectionQuestion();
  }
  edit(que: Question) {
    this.questionControl.setValue(que);
    // this.choosenQuestions.push(que);
  }
  remove(index: number) {
    this.#collectionStore.remove(index);
    // this.choosenQuestions = this.choosenQuestions.filter(q => q.id != que.id);
  }
  return() {
    // this.#dragStore.openAndCloseCollectionQuestions(false);
  }
  add() {
    // this.addQuestionsEmit.emit(this.choosenQuestions)
  }
  saveEdit() {
    if (this.questionControl.value) {
      this.#collectionStore.update(this.questionControl.value)
      this.questionControl.setValue(null);
    }
  }
}
